// export const IMG_URL = "http://127.0.0.1:2002";
export const IMG_URL = "https://node.profcymafoundation.com";

// export const NODE_URL = "http://node.whatsapp.profcyma.org";

export const Select2Data = async (data, name, other = false) => {
  const result = data.map((data) => ({
    value: data?.id,
    label: data?.name || data?.description || data?.template_id,
    name: name,
  }));

  if (other) {
    result.push({ value: "0", label: "Other", name: name });
  }
  return result;
};

export const handleDecimalKeyDown = (e) => {
  const allowedKeys = [
    "Backspace",
    "Tab",
    "ArrowLeft",
    "ArrowRight",
    "Delete",
    ".",
    "Home",
    "End",
  ];
  const isNumber = /^[0-9]$/.test(e.key);

  if (!isNumber && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }

  // Prevent multiple dots
  if (e.key === "." && e.currentTarget.value.includes(".")) {
    e.preventDefault();
  }
};

export const formatDate = (dateString, newFormat = false) => {
  if (newFormat) {
    const date = new Date(dateString);

    const pad = (n) => n.toString().padStart(2, "0");

    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const day = pad(date.getDate());

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
  if (!dateString) return "";
  const date = new Date(dateString);
  return `${date.toISOString().slice(0, 10)}`; // returns 'YYYY-MM-DD'
};

export const Last_Login = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    // second: '2-digit',
    hour12: true, // Set to true for AM/PM format
  };
  const time = date.toLocaleTimeString("en-US", options);
  return `${time} on ${date.toISOString().slice(0, 10)}`; // returns 'YYYY-MM-DD'
};
